import React from 'react';
import './Projects.css';

const Projects: React.FC = () => {
  const projects = [
    {
      title: "Arabic Memory Game",
      description:
        "My first JavaScript project created for my son - an educational memory game in Arabic to help children learn while having fun.",
      technologies: ["JavaScript", "HTML", "CSS"],
      type: "Educational Game",
      link: "/memory/intro.html",
    },
    {
      title: "Who Wants to Be Millionaire",
      description:
        "Arabic version of the popular quiz game, demonstrating progressive JavaScript skills and interactive gameplay mechanics.",
      technologies: ["JavaScript", "HTML", "CSS", "Game Logic"],
      type: "Quiz Game",
    },
    {
      title: "Arabic Time Learning Tool",
      description:
        "An interactive application to help children learn and practice reading time in Arabic, with challenge modes and progress tracking.",
      technologies: ["JavaScript", "HTML", "CSS", "Educational Logic"],
      type: "Educational Tool",
      link: "/learnClock/index.html",
    },
    {
      title: "Children Focus Examination",
      description:
        "A concentration and focus testing application for children, with result tracking and performance analysis capabilities.",
      technologies: ["JavaScript", "HTML", "CSS", "Analytics"],
      type: "Assessment Tool",
      link: "/conGame/exam.html",
    },
    {
      title: "Proto-ObjectsArray Library",
      description:
        "An open-source JavaScript library published on NPM, extending array functionality with object-oriented approaches.",
      technologies: ["JavaScript", "Node.js", "NPM"],
      type: "Open Source Library",
      link: "https://www.npmjs.com/package/proto-objectsarray",
    },
    {
      title: "Family Tree Website (khamis.info)",
      description:
        "A comprehensive family tree website built using WebTrees, allowing family members to explore genealogy and family history.",
      technologies: ["PHP", "MySQL", "WebTrees", "Family History"],
      type: "Genealogy Platform",
    },
    {
      title: "JosianEng.com",
      description:
        "Commercial website for my brother-in-law's engineering business, showcasing services and facilitating client communication.",
      technologies: ["PHP", "HTML", "CSS", "JavaScript", "Business"],
      type: "Business Website",
    },
    {
      title: "Structural Steel Analysis Program",
      description:
        "A sophisticated Node.js application for structural steel analysis and design, specifically for trusses and Open Web Joists. (Proprietary)",
      technologies: ["Node.js", "Structural Engineering", "Mathematics", "CAD"],
      type: "Engineering Software",
    },
    {
      title: "AI-Powered Field Force Platform",
      description:
        "Leading the development of computer-vision pipelines with object detection and OCR, plus LangChain-based agents for automated decision-making at Repzo.",
      technologies: [
        "Node.js",
        "Computer Vision",
        "LangChain",
        "OCR",
        "AWS",
        "AI/ML",
      ],
      type: "Enterprise AI Platform",
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2>Projects & Contributions</h2>
        <p className="projects-intro">
          From educational games to enterprise AI platforms, here's a showcase of my journey through various technologies and domains.
        </p>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-type">{project.type}</div>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
              {project.link && (
                <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                  View Project →
                </a>
              )}
            </div>
          ))}
        </div>
        <div className="projects-note">
          <p>
            <strong>Note:</strong> While some early projects like the BOQ tool (boq.steelnodes.com) 
            are no longer maintained, they represent important milestones in my development journey, 
            bridging my civil engineering background with programming expertise.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Projects;
